import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Badge } from "../../components/ui-bits";
import { useAgentClient, NeedClient } from "../../components/AgentContext";
import { metaFor, downloadBlob } from "../../lib/services";
import { toast } from "sonner";
import { File, SealCheck, DownloadSimple, Paperclip } from "@phosphor-icons/react";

export function AgentDocuments() {
  const { sel, selClient } = useAgentClient();
  const [docs, setDocs] = useState([]);
  const [folder, setFolder] = useState("Other");
  const load = () => sel && api.get(`/agent/documents?client_email=${encodeURIComponent(sel)}`).then((r) => setDocs(r.data)).catch(() => setDocs([]));
  useEffect(() => { load(); }, [sel]);

  const groups = docs.reduce((g, d) => { const k = d.service || d.folder || "Other"; (g[k] = g[k] || []).push(d); return g; }, {});
  const dl = async (d) => {
    try { const r = await api.get(`/documents/${d.id}/download`, { responseType: "blob" }); downloadBlob(r.data, d.name); }
    catch { toast.error("Could not download file"); }
  };
  const share = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try {
      await api.post(`/agent/documents/upload?client_email=${encodeURIComponent(sel)}&folder=${encodeURIComponent(folder)}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Document shared with client"); load();
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
  };

  return (
    <div>
      <PageHead eyebrow={selClient ? `Document Vault · ${selClient.company}` : "Document Vault"} title="Documents">
        {selClient && (
          <div className="flex items-center gap-2">
            <select data-testid="adoc-folder" value={folder} onChange={(e) => setFolder(e.target.value)} className="border border-black/20 rounded-sm px-2 py-2 text-sm">
              {[...(selClient.services || []), "Other"].map((s) => <option key={s}>{s}</option>)}
            </select>
            <label data-testid="adoc-upload" className="bg-[#00A86B] hover:brightness-95 text-white px-4 py-2 rounded-sm text-sm inline-flex items-center gap-2 cursor-pointer">
              <Paperclip size={15} /> Share document<input type="file" hidden onChange={(e) => e.target.files[0] && share(e.target.files[0])} />
            </label>
          </div>
        )}
      </PageHead>
      <NeedClient>
        {docs.length === 0 && <p className="card p-8 text-sm text-[#888] text-center">No documents for this client yet.</p>}
        <div className="space-y-4">
          {Object.entries(groups).map(([svc, items]) => {
            const m = metaFor(svc);
            return (
              <div key={svc} data-testid={`adoc-group-${svc.toLowerCase()}`} className="card p-5">
                <p className="font-head font-bold mb-3 flex items-center gap-2"><m.Icon size={18} weight="fill" style={{ color: m.color }} /> {svc} <span className="text-xs text-[#888] font-normal">({items.length})</span></p>
                <div className="divide-y divide-black/10">
                  {items.map((d, i) => (
                    <div key={d.id} data-testid={`adoc-${svc.toLowerCase()}-${i}`} className="flex items-center gap-3 py-2 text-sm">
                      {d.source === "agent" ? <SealCheck size={18} weight="fill" className="text-[#00A86B]" /> : <File size={18} className="text-[#002FA7]" />}
                      <span className="flex-1 truncate">{d.name}</span>
                      <Badge status={d.source === "agent" ? "completed" : "default"}>{d.source === "agent" ? "Deliverable" : "Client upload"}</Badge>
                      <span className="text-xs text-[#888] hidden sm:inline tnum">{(d.uploaded_at || "").slice(0, 10)}</span>
                      <button data-testid={`adoc-dl-${svc.toLowerCase()}-${i}`} onClick={() => dl(d)} className="text-[#002FA7] hover:bg-[#002FA7]/10 p-1 rounded-sm"><DownloadSimple size={16} /></button>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </NeedClient>
    </div>
  );
}
